module.exports = __webpack_public_path__ + "media/images/app/testimonials/carousel-fourth-2054aa76d62c11977a7ce8583077823f.webp";